var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.storification
    ? _c(
        "div",
        {
          ref: "screen-instagram",
          staticClass: "preview-share-after-post background-img",
          attrs: { id: "screen-instagram" },
        },
        [
          _vm.storification.image
            ? _c("img", {
                staticClass: "share-img",
                attrs: {
                  crossorigin: "anonymous",
                  src: _vm.storification.image,
                  alt: "",
                },
                on: {
                  load: _vm.shareLoadImage,
                  error: _vm.shareLoadErrorImage,
                },
              })
            : _vm._e(),
          _vm.storification.image
            ? _c("p", { staticClass: "share-username" }, [
                _vm._v("@" + _vm._s(_vm.storification.username)),
              ])
            : _vm._e(),
          _c("img", {
            staticClass: "carousel-storification",
            attrs: {
              hidden: !_vm.storification.isCarousel,
              src: require("../../assets/img/carousel.svg"),
            },
          }),
          _vm.link && _vm.link.url && _vm.link.isActive
            ? _c(
                "div",
                {
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} link-container-view style-color-0`,
                  attrs: {
                    "data-name": "Link",
                    "data-init":
                      _vm.link.initialDatas &&
                      JSON.stringify(_vm.link.initialDatas),
                  },
                },
                [
                  _c("img", {
                    staticClass: "link-img",
                    attrs: {
                      src: require("../../assets/img/icon_instagram_link.svg"),
                      alt: "Link",
                    },
                  }),
                  _c("p", { staticClass: "link-txt" }, [
                    _vm._v(
                      _vm._s(
                        _vm.link.text
                          ? _vm.link.text.toUpperCase()
                          : _vm.link.url
                              .split("/")[2]
                              .toUpperCase()
                              .split("?")[0]
                              .replace("WWW.", "")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }